import { render, staticRenderFns } from "./TermPolicyModal.vue?vue&type=template&id=3aff7740&scoped=true"
import script from "./TermPolicyModal.vue?vue&type=script&lang=js"
export * from "./TermPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./TermPolicyModal.vue?vue&type=style&index=0&id=3aff7740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff7740",
  null
  
)

export default component.exports